import React from 'react';
import PropTypes from 'prop-types';
import htmlReactParser from 'html-react-parser';

import './filter-field.scss';

const FilterField = (props) => {
	const {
		id,
		type,
		label,
		checked,
		value,
		onChange,
	} = props;

	return (
		<div className="C3-filter__field">
			<label htmlFor={id}>
				<input type={type} id={id} checked={checked} value={value} onChange={onChange} />
				<span>{ htmlReactParser(label) }</span>
			</label>
		</div>
	);
};

FilterField.defaultProps = {
	type: 'checkbox',
	label: '',
	checked: false,
	value: '',
	onChange: () => {},
};

FilterField.propTypes = {
	id: PropTypes.string.isRequired,
	type: PropTypes.string,
	label: PropTypes.string,
	checked: PropTypes.bool,
	value: PropTypes.string,
	onChange: PropTypes.func,
};

export default FilterField;
